// Tunnels API module

import { apiRequest } from '../services/api';

const API_URL: string = process.env.REACT_APP_API_URL || '';

export interface Tunnel {
  id?: string;
  tunnel_id?: string;
  name?: string;
  game?: string;
  protocol?: string;
  local_port?: number;
  local_ip?: string;
  public_port?: number;
  public_host?: string;
  status?: string;
  [key: string]: unknown;
}

/**
 * Tunnels API client - uses centralized apiRequest for proper authentication
 */
export const tunnelsAPI = {
  /**
   * Get all tunnels for authenticated user
   * @returns List of tunnels
   */
  getAll: (): Promise<Tunnel[]> =>
    apiRequest<Tunnel[]>('/v1/tunnels'),

  /**
   * Get tunnel by ID
   * @param id - Tunnel ID
   * @returns Tunnel data
   */
  getById: (id: string): Promise<Tunnel> =>
    apiRequest<Tunnel>(`/v1/tunnels/${id}`),

  /**
   * Create new tunnel
   * @param data - Tunnel data
   * @returns Created tunnel
   */
  create: (data: unknown): Promise<Tunnel> => {
    // eslint-disable-next-line no-console
    console.log('API create tunnel called with data:', data);
    // eslint-disable-next-line no-console
    console.log('API URL:', `${API_URL}/v1/tunnels`);
    return apiRequest<Tunnel>('/v1/tunnels', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  /**
   * Update tunnel
   * @param id - Tunnel ID
   * @param data - Updated data
   * @returns Updated tunnel
   */
  update: (id: string, data: unknown): Promise<Tunnel> =>
    apiRequest<Tunnel>(`/v1/tunnels/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),

  /**
   * Delete tunnel
   * @param id - Tunnel ID
   * @returns Deletion result
   */
  delete: (id: string): Promise<unknown> =>
    apiRequest(`/v1/tunnels/${id}`, {
      method: 'DELETE',
    }),

  /**
   * Verify custom domain
   * @param id - Tunnel ID
   * @param data - Domain data
   * @returns Verification result
   */
  verifyDomain: (id: string, data: unknown): Promise<unknown> =>
    apiRequest(`/v1/tunnels/${id}/verify-domain`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  /**
   * Update tunnel settings
   * @param id - Tunnel ID
   * @param data - Settings data
   * @returns Updated tunnel
   */
  updateSettings: (id: string, data: unknown): Promise<Tunnel> =>
    apiRequest<Tunnel>(`/v1/tunnels/${id}/settings`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),

  /**
   * Change tunnel node
   * @param id - Tunnel ID
   * @param nodeId - New node ID
   * @returns Change result
   */
  changeNode: (id: string, nodeId: string): Promise<unknown> =>
    apiRequest(`/v1/tunnels/${id}/change-node`, {
      method: 'POST',
      body: JSON.stringify({ node_id: nodeId }),
    }),
};
